export default __webpack_public_path__ + "static/media/product-img.e29c5819.jpg";